module.exports = __webpack_public_path__ + "img/cameroon.54425b5e.jpg";